var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pageNotFoundComponent',{attrs:{"lang":_vm.lang,"title":'pages.notFoundPage',"general":"general"}})}
var staticRenderFns = []

export { render, staticRenderFns }